import { iconSpriteUrl } from './art.js';
import { cx } from './color.js';
import styles from './Icon.module.css';

/** Id's in assets/icons.svg (Lucide, ISC); lijst: scripts/icon-sources.json. Alleen een type. */
export type IconId =
  | 'calendar'
  | 'calendar-days'
  | 'calendar-plus'
  | 'calendar-clock'
  | 'calendar-x'
  | 'calendar-check'
  | 'calendar-range'
  | 'check'
  | 'circle-check'
  | 'x'
  | 'plus'
  | 'minus'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-down'
  | 'chevron-up'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-right-left'
  | 'undo-2'
  | 'redo-2'
  | 'lock'
  | 'lock-open'
  | 'settings'
  | 'user'
  | 'users'
  | 'user-plus'
  | 'circle-user-round'
  | 'house'
  | 'list-todo'
  | 'list-checks'
  | 'star'
  | 'gift'
  | 'trophy'
  | 'coins'
  | 'hourglass'
  | 'clock'
  | 'alarm-clock'
  | 'bell'
  | 'mail'
  | 'log-out'
  | 'log-in'
  | 'shield-check'
  | 'shield'
  | 'key-round'
  | 'smartphone'
  | 'tablet'
  | 'tablet-smartphone'
  | 'monitor'
  | 'wifi'
  | 'wifi-off'
  | 'cloud-off'
  | 'cloud'
  | 'moon'
  | 'sun'
  | 'sunrise'
  | 'sunset'
  | 'repeat'
  | 'move'
  | 'pencil'
  | 'trash-2'
  | 'copy'
  | 'search'
  | 'filter'
  | 'info'
  | 'circle-alert'
  | 'triangle-alert'
  | 'circle-help'
  | 'eye'
  | 'eye-off'
  | 'map-pin'
  | 'car'
  | 'sparkles'
  | 'party-popper'
  | 'inbox'
  | 'thumbs-up'
  | 'grip-vertical'
  | 'ellipsis'
  | 'menu'
  | 'qr-code'
  | 'link'
  | 'palette'
  | 'image'
  | 'refresh-cw'
  | 'rotate-ccw'
  | 'heart'
  | 'hand'
  | 'history'
  | 'sliders-horizontal'
  | 'globe'
  | 'printer'
  | 'download'
  | 'mic'
  | 'volume-2'
  | 'volume-x'
  | 'layout-grid'
  | 'rows-3'
  | 'columns-3'
  | 'loader-circle'
  | 'baby'
  | 'shopping-cart'
  | 'shopping-basket'
  | 'chef-hat'
  | 'utensils'
  | 'cooking-pot'
  | 'refrigerator'
  | 'camera'
  | 'circle-play'
  | 'circle-stop'
  | 'book-open'
  | 'book-open-text'
  | 'list'
  // Golf 2: afspraak-editor op volledig scherm en terug.
  | 'maximize-2'
  | 'minimize-2';

export interface IconProps {
  id: IconId;
  /** Zijde in px (standaard 24; kiosk-kinderknoppen 48). */
  size?: number;
  /** Alleen als het icoon zelf betekenis draagt (zonder zichtbare tekst ernaast). */
  label?: string;
  class?: string | undefined;
}

/**
 * Lijnicoon uit de SVG-sprite (statisch bestand, zelfde origin). Neemt `currentColor` over.
 * Geen inline paden: de sprite komt nooit in de JS-bundle (§12.2-budget).
 */
/**
 * Pictogrammen met een richting (pijlen, chevrons, uitloggen): in rechts-naar-links gespiegeld
 * (golf 3, docs/DESIGN.md §8.T). Klok, cijfers en gewone symbolen spiegelen nooit.
 */
export const DIRECTIONAL_ICONS: ReadonlySet<string> = new Set([
  'arrow-left',
  'arrow-right',
  'chevron-left',
  'chevron-right',
  'chevrons-left',
  'chevrons-right',
  'log-in',
  'log-out',
  'undo-2',
  'redo-2',
  'send',
  'reply',
]);

export function Icon({ id, size = 24, label, class: cls }: IconProps) {
  return (
    <svg
      class={cx(styles.icon, DIRECTIONAL_ICONS.has(id) && styles.directional, cls)}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : 'true'}
      focusable="false"
    >
      <use href={`${iconSpriteUrl()}#i-${id}`} />
    </svg>
  );
}
